import type { UserManager } from "oidc-client-ts";
import { useContext, useEffect, useState } from "react";
import { UserManagersContext } from "@/context/user-managers";
import usePersistedBoundStore from "@/store/persisted-bound-store";
import { isEvbasicRealm, isEvcoreRealm } from "@/utils/process";

export default function useCurrentUserManager() {
  const [currentUserManager, setCurrentUserManager] = useState<UserManager>();

  // Use the context directly to check if it's available (same pattern as Safe version)
  const context = useContext(UserManagersContext);
  const realm = usePersistedBoundStore.use.realm();

  useEffect(() => {
    if (context) {
      if (isEvcoreRealm(realm)) {
        setCurrentUserManager(context.evcoreUserManager);
      }
      if (isEvbasicRealm(realm)) {
        setCurrentUserManager(context.evbasicUserManager);
      }
    }
  }, [realm, context]);

  return currentUserManager;
}

// Safe version that doesn't throw when provider is not available
export function useCurrentUserManagerSafe() {
  const [currentUserManager, setCurrentUserManager] = useState<UserManager>();

  // Use the context directly to check if it's available
  const context = useContext(UserManagersContext);
  const realm = usePersistedBoundStore.use.realm();

  useEffect(() => {
    if (context) {
      if (isEvcoreRealm(realm)) {
        setCurrentUserManager(context.evcoreUserManager);
      }
      if (isEvbasicRealm(realm)) {
        setCurrentUserManager(context.evbasicUserManager);
      }
    }
  }, [realm, context]);

  return currentUserManager;
}
